import { pickT } from "@repo/shared";
import { StatusBadge } from "@/components/ui/status-badge";
import { T } from "./flow-stage-badge.i18n";

/**
 * Readable name for a process stage. Falls back to the raw value with its
 * underscores spaced out, so an unmapped status degrades to something legible
 * rather than disappearing.
 */
export function flowStageLabel(status: string, language: string): string {
  return pickT(T, language)[status as keyof typeof T.en_GB] ?? status.replaceAll("_", " ");
}

/**
 * The stage, as a badge.
 *
 * Goes through `StatusBadge` so the variant comes from the central status map
 * (DESIGN.md › Components › Badges) — never coloured at the call site.
 */
export function FlowStageBadge({
  status,
  language,
  className,
}: {
  status: string;
  language: string;
  className?: string;
}) {
  return (
    <StatusBadge status={status} className={className}>
      {flowStageLabel(status, language)}
    </StatusBadge>
  );
}
